var map = {
	"./varais-1.jpg": 451,
	"./varais-10-copia.jpg": 452,
	"./varais-11-copia.jpg": 453,
	"./varais-12-copia.jpg": 454,
	"./varais-13-copia.jpg": 455,
	"./varais-14-copia.jpg": 456,
	"./varais-15-copia.jpg": 457,
	"./varais-16-copia.jpg": 458,
	"./varais-17-copia.jpg": 459,
	"./varais-2.jpg": 460,
	"./varais-3.jpg": 461,
	"./varais-4.jpg": 462,
	"./varais-6.jpg": 463,
	"./varais-9-copia.jpg": 464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;